export const MuiButton = {
  defaultProps: {
    sx: {
      textTransform: "none",
    },
  },
};
